import { RRule, RRuleSet} from "rrule";
import moment from 'moment';
// import { DateTime } from 'luxon';


const rruleUtil = {

  rruleWeekdays: [
    RRule.MO,
    RRule.TU,
    RRule.WE,
    RRule.TH,
    RRule.FR,
    RRule.SA,
    RRule.SU,
  ],

  generateRRule: (startDate, startTime, endDate, endTime, recurringWeekdays) => {
      startTime = startTime ? startTime:'00:00';
      endTime = endTime ? endTime:'00:00';
  
      // const endDate = endDate ? endDate:moment().startOf("day").add(365, "days").format('YYYY-MM-DD');
      const startDateTime = moment(`${startDate} ${startTime}`, 'YYYY-MM-DD HH:mm');
      const endDateTime = endDate ? moment(`${endDate} ${endTime}`, 'YYYY-MM-DD HH:mm'):null;
  
      if(!recurringWeekdays){
        throw 'Recurring Weekdays is required';
      }

      const weekDays = recurringWeekdays.map((d) => rruleUtil.rruleWeekdays[d]);
  
      // const localTzID = (DateTime.local().zoneName);
      // const dtStart = `DTSTART;TZID=${localTzID}:${startDateTime.format('YYYYMMDD[T]HHmmss')}`;
      // const frequency = `RRULE:FREQ=WEEKLY;INTERVAL=1`;
      // const days = `;BYDAY=${weekDays}`;
      // const until = `;UNTIL=${endDateTime ? endDateTime.format('YYYYMMDD'):''}`;
  
      // const ruleString = `${dtStart}\n${frequency}${weekDays && weekDays.length >0 ? days:''}${endDateTime ? until:''}`;
      // console.log(ruleString);
      // const rrule = rrulestr(ruleString);
  
      const repeatWeekInterval = 1;
      const rrule = new RRule({
        freq: RRule.WEEKLY,
        until: endDateTime ? endDateTime.utc().toDate():null,
        interval: repeatWeekInterval,
        byweekday: weekDays,
        dtstart: startDateTime.utc().toDate(),
        // tzid: localTzID
      })

      // console.log('generated rrule: \n', rrule.toString());
  
      return rrule;
    },
    rruleSetWithExDates(rrule, excludeDates){
      const rruleSet = new RRuleSet()
      rruleSet.rrule(rrule);

      const startTime = moment(rrule.options.dtstart).format('HH:mm');

      // console.log(rrule);
      let exclusionObjs = [];
      if(excludeDates && excludeDates.length > 0){
        excludeDates.forEach(date => {
          const excludeDateTime = moment(`${date} ${startTime}`, 'YYYY-MM-DD HH:mm');
          rruleSet.exdate(excludeDateTime.toDate())
        });

        exclusionObjs = excludeDates.map(ex => { return {date: ex} });
      }

      return { rruleSet, exclusionObjs }
    }
}

export default rruleUtil;